import { LoaderFunctionArgs, ShouldRevalidateFunction } from 'react-router-dom';

import { groupInnerRoutes } from '@/console/app/routes/groups/group-inner-routes';
import { TGroupLoaderItem } from '@/console/features/groups/components/groups.types';
import { NoGroupSelected } from '@/shared/features/groups/components/no-group-selected/no-group-selected';
import { getGroupAncestorCrumb } from '@/shared/features/groups/utils/group-hierarchy/get-group-ancestor-crumb';
import { TCustomRouteObject } from '@/shared/types/router.types';

const smartRevalidation: ShouldRevalidateFunction = ({
  currentUrl,
  nextUrl,
  formMethod,
}) => {
  if (formMethod && formMethod !== 'GET') {
    return true;
  }

  return (
    currentUrl.pathname !== nextUrl.pathname ||
    currentUrl.search !== nextUrl.search
  );
};

export const groupsRoute: TCustomRouteObject = {
  path: '/groups',
  lazy: async () => {
    const { ResourceGroupsListRoute } = await import('./groups');
    return { Component: ResourceGroupsListRoute };
  },
  shouldRevalidate: smartRevalidation,
  loader: async () => {
    const { resourceGroupsLoader } = await import('./groups');
    return resourceGroupsLoader();
  },
  handle: {
    crumb: {
      label: 'groups',
      localized: true,
    },
    entity: 'ResourceGroup',
  },
  children: [
    {
      index: true,
      Component: () => <NoGroupSelected />,
    },
    {
      path: ':groupId',
      lazy: async () => {
        const { ResourceGroupRoute } = await import('./groups');
        return { Component: ResourceGroupRoute };
      },
      loader: async (args: LoaderFunctionArgs) => {
        const { resourceGroupLoader } = await import('./groups');
        return resourceGroupLoader(args);
      },
      shouldRevalidate: () => true,
      handle: {
        crumb: {
          label: (data: TGroupLoaderItem) => data?.group?.name,
          ancestor: (data: TGroupLoaderItem) => getGroupAncestorCrumb(data),
        },
      },
      children: groupInnerRoutes,
    },
  ],
};
